module.exports = __webpack_public_path__ + "img/Mask Group 2919@2x.6e312b87.png";